function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 15.111A7.111 7.111 0 118 .89 7.111 7.111 0 018 15.11zm-3.357-4.657a.647.647 0 00.914.915L8.003 8.92l2.449 2.451a.646.646 0 00.914-.915l-2.45-2.451 2.46-2.46a.647.647 0 00-.915-.915L8.003 7.09 5.548 4.634a.646.646 0 10-.914.915l2.455 2.457-2.446 2.448z",
  fill: "#148CFC",
  fillRule: "evenodd"
});

var SvgDelete = function SvgDelete(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default SvgDelete;